export const DEFAULT_MISC_URL = '//img.ridicdn.net';

// production 환경에서 docker를 사용하지 않으므로 기본값을 넣어줌
export const LIBRARY_API_BASE_URL =
  process.env.LIBRARY_API_BASE_URL || 'https://library-api.ridibooks.com';

export const BOOK_API_BASE_URL =
  process.env.BOOK_API_BASE_URL || 'https://book-api.ridibooks.com';

export const VIEWER_API_BASE_URL =
  process.env.VIEWER_API_BASE_URL || 'https://ridibooks.com';

export const ACCOUNT_BASE_URL =
  process.env.ACCOUNT_BASE_URL || 'https://account.ridibooks.com';


export const READING_DATA_BASE_URL =
  process.env.READING_DATA_API_BASE_URL ||
  'https://reading-data-api.ridibooks.com';

export const RECOMMENDATION_API_BASE_URL =
  process.env.RECOMMENDATION_API_BASE_URL || 'https://recommend-api-v2.ridibooks.com'



// WEBPACK FOOTER //
// ./common/constants/defaultUrl.ts